import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Curriculum from "@/pages/Curriculum";
import CurriculumSales from "@/pages/CurriculumSales";
import Workbooks from "@/pages/Workbooks";
import CourseDetail from "@/pages/CourseDetail";
import LessonView from "@/pages/LessonView";
import Pricing from "@/pages/Pricing";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Auth from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import Tutor from "@/pages/Tutor";
import Admin from "@/pages/Admin";
import Services from "@/pages/Services";
import CoverSchool from "@/pages/CoverSchool";
import CoverSchoolEnroll from "@/pages/CoverSchoolEnroll";
import CoverSchoolDocument from "@/pages/CoverSchoolDocument";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Landing />} />
              <Route path="/curriculum" element={<CurriculumSales />} />
              <Route path="/curriculum/browse" element={<Curriculum />} />
              <Route path="/workbooks" element={<Workbooks />} />
              <Route path="/course/:courseId" element={<CourseDetail />} />
              <Route path="/lesson/:lessonId" element={<ProtectedRoute><LessonView /></ProtectedRoute>} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/services" element={<Services />} />
              <Route path="/cover-school" element={<CoverSchool />} />
              <Route path="/cover-school/enroll" element={<ProtectedRoute><CoverSchoolEnroll /></ProtectedRoute>} />
              <Route path="/cover-school/document/:docType" element={<ProtectedRoute><CoverSchoolDocument /></ProtectedRoute>} />
              <Route path="/checkout/success" element={<CheckoutSuccess />} />
              <Route path="/login" element={<Auth mode="login" />} />
              <Route path="/register" element={<Auth mode="register" />} />
              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/tutor" element={<ProtectedRoute><Tutor /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
